import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import useTutorialChapters from '../../pages/system/tutorials/useTutorialChapters';
import TutorialDialog from './TutorialDialog';
import styles from './TutorialsBanner.module.css';

/**
 * Lembrete chamativo de que existe a série completa de tutoriais.
 * inline: abre os vídeos do capítulo 1 num modal, sem sair da tela (usado no meio
 * da configuração inicial); sem inline, leva para a aba Tutoriais.
 * compact: versão de uma linha, para o rodapé de cards.
 */
function TutorialsBanner({ inline = false, compact = false }) {
  const navigate = useNavigate();
  const { chapters } = useTutorialChapters();
  const [open, setOpen] = useState(false);
  const total = chapters.reduce((sum, chapter) => sum + (chapter.lessons || []).length, 0);
  const firstChapter = chapters[0]?.lessons || [];

  const handleClick = () => {
    if (inline && firstChapter.length) setOpen(true);
    else navigate('/system/tutorials');
  };

  const text = total
    ? `São ${total} vídeos curtos, do primeiro agendamento ao financeiro. Assista quando quiser.`
    : 'Vídeos curtos, do primeiro agendamento ao financeiro. Assista quando quiser.';

  return (
    <>
      <button
        type="button"
        className={`${styles.banner} ${compact ? styles.compact : ''}`}
        onClick={handleClick}
      >
        <span className={styles.play}><PlayArrowRoundedIcon /></span>
        <span className={styles.body}>
          <strong className={styles.title}>Precisa de ajuda? Temos um tutorial completo em vídeo</strong>
          {!compact && <span className={styles.text}>{text}</span>}
        </span>
        <span className={styles.cta}>
          {inline ? 'Assistir agora' : 'Ver os tutoriais'}
          <ArrowForwardIcon fontSize="small" />
        </span>
      </button>
      {inline && (
        <TutorialDialog
          open={open}
          onClose={() => setOpen(false)}
          lessons={firstChapter}
          title={chapters[0]?.title || 'Primeiros passos'}
        />
      )}
    </>
  );
}

export default TutorialsBanner;
